/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-07-02 17:27:32
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-07-02 17:29:26
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\ai-assistant-lib\src\utils\file.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

// 解决文件跨域问题，将绝对路径换成相对路径
export function getFileUrl(url) {
  if (/http(s)?:\/\//.test(url)) {
    // 绝对路径
    if (url.indexOf(window.location.origin) === 0) {
      // 当前域名
      return url.substring(window.location.origin.length);
    }
    return url.substring(url.indexOf('/', 8));
  }
  return url;
}

//文件下载时，转换成blob
export function getBlob(url, cb) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (xhr.status === 200) {
      cb(xhr.response);
    }
  };
  xhr.send();
}

/**
 * 下载文件
 * @param {Object} file 文件对象
 */
export function downloadFile(file) {
  let url = getFileUrl(file.url || file.response.data.url);
  getBlob(url, function (blob) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, file.name);
    } else {
      let link = document.createElement('a'); // 创建元素
      link.style.cursor = 'pointer';
      link.href = window.URL.createObjectURL(blob);
      link.download = file.name; //文件命名
      link.click(); // 点击下载
      window.URL.revokeObjectURL(url);
    }
  });
}
